import { amber } from "./dark/amber.mjs";
import { blue } from "./dark/blue.mjs";
import { bronze } from "./dark/bronze.mjs";
import { brown } from "./dark/brown.mjs";
import { crimson } from "./dark/crimson.mjs";
import { cyan } from "./dark/cyan.mjs";
import { gold } from "./dark/gold.mjs";
import { grass } from "./dark/grass.mjs";
import { gray } from "./dark/gray.mjs";
import { green } from "./dark/green.mjs";
import { indigo } from "./dark/indigo.mjs";
import { lime } from "./dark/lime.mjs";
import { mauve } from "./dark/mauve.mjs";
import { mint } from "./dark/mint.mjs";
import { olive } from "./dark/olive.mjs";
import { orange } from "./dark/orange.mjs";
import { pink } from "./dark/pink.mjs";
import { plum } from "./dark/plum.mjs";
import { purple } from "./dark/purple.mjs";
import { red } from "./dark/red.mjs";
import { sage } from "./dark/sage.mjs";
import { sand } from "./dark/sand.mjs";
import { sky } from "./dark/sky.mjs";
import { slate } from "./dark/slate.mjs";
import { teal } from "./dark/teal.mjs";
import { tomato } from "./dark/tomato.mjs";
import { violet } from "./dark/violet.mjs";
import { yellow } from "./dark/yellow.mjs";
import { amberA } from "./dark/amberA.mjs";
import { blueA } from "./dark/blueA.mjs";
import { bronzeA } from "./dark/bronzeA.mjs";
import { brownA } from "./dark/brownA.mjs";
import { crimsonA } from "./dark/crimsonA.mjs";
import { cyanA } from "./dark/cyanA.mjs";
import { goldA } from "./dark/goldA.mjs";
import { grassA } from "./dark/grassA.mjs";
import { grayA } from "./dark/grayA.mjs";
import { greenA } from "./dark/greenA.mjs";
import { indigoA } from "./dark/indigoA.mjs";
import { limeA } from "./dark/limeA.mjs";
import { mauveA } from "./dark/mauveA.mjs";
import { mintA } from "./dark/mintA.mjs";
import { oliveA } from "./dark/oliveA.mjs";
import { orangeA } from "./dark/orangeA.mjs";
import { pinkA } from "./dark/pinkA.mjs";
import { plumA } from "./dark/plumA.mjs";
import { purpleA } from "./dark/purpleA.mjs";
import { redA } from "./dark/redA.mjs";
import { sageA } from "./dark/sageA.mjs";
import { sandA } from "./dark/sandA.mjs";
import { skyA } from "./dark/skyA.mjs";
import { slateA } from "./dark/slateA.mjs";
import { tealA } from "./dark/tealA.mjs";
import { tomatoA } from "./dark/tomatoA.mjs";
import { violetA } from "./dark/violetA.mjs";
import { yellowA } from "./dark/yellowA.mjs";
import { amber as amber2 } from "./light/amber.mjs";
import { blue as blue2 } from "./light/blue.mjs";
import { bronze as bronze2 } from "./light/bronze.mjs";
import { brown as brown2 } from "./light/brown.mjs";
import { crimson as crimson2 } from "./light/crimson.mjs";
import { cyan as cyan2 } from "./light/cyan.mjs";
import { gold as gold2 } from "./light/gold.mjs";
import { grass as grass2 } from "./light/grass.mjs";
import { gray as gray2 } from "./light/gray.mjs";
import { green as green2 } from "./light/green.mjs";
import { indigo as indigo2 } from "./light/indigo.mjs";
import { lime as lime2 } from "./light/lime.mjs";
import { mauve as mauve2 } from "./light/mauve.mjs";
import { mint as mint2 } from "./light/mint.mjs";
import { olive as olive2 } from "./light/olive.mjs";
import { orange as orange2 } from "./light/orange.mjs";
import { pink as pink2 } from "./light/pink.mjs";
import { plum as plum2 } from "./light/plum.mjs";
import { purple as purple2 } from "./light/purple.mjs";
import { red as red2 } from "./light/red.mjs";
import { sage as sage2 } from "./light/sage.mjs";
import { sand as sand2 } from "./light/sand.mjs";
import { sky as sky2 } from "./light/sky.mjs";
import { slate as slate2 } from "./light/slate.mjs";
import { teal as teal2 } from "./light/teal.mjs";
import { tomato as tomato2 } from "./light/tomato.mjs";
import { violet as violet2 } from "./light/violet.mjs";
import { yellow as yellow2 } from "./light/yellow.mjs";
import { amberA as amberA2 } from "./light/amberA.mjs";
import { blueA as blueA2 } from "./light/blueA.mjs";
import { bronzeA as bronzeA2 } from "./light/bronzeA.mjs";
import { brownA as brownA2 } from "./light/brownA.mjs";
import { crimsonA as crimsonA2 } from "./light/crimsonA.mjs";
import { cyanA as cyanA2 } from "./light/cyanA.mjs";
import { goldA as goldA2 } from "./light/goldA.mjs";
import { grassA as grassA2 } from "./light/grassA.mjs";
import { grayA as grayA2 } from "./light/grayA.mjs";
import { greenA as greenA2 } from "./light/greenA.mjs";
import { indigoA as indigoA2 } from "./light/indigoA.mjs";
import { limeA as limeA2 } from "./light/limeA.mjs";
import { mauveA as mauveA2 } from "./light/mauveA.mjs";
import { mintA as mintA2 } from "./light/mintA.mjs";
import { oliveA as oliveA2 } from "./light/oliveA.mjs";
import { orangeA as orangeA2 } from "./light/orangeA.mjs";
import { pinkA as pinkA2 } from "./light/pinkA.mjs";
import { plumA as plumA2 } from "./light/plumA.mjs";
import { purpleA as purpleA2 } from "./light/purpleA.mjs";
import { redA as redA2 } from "./light/redA.mjs";
import { sageA as sageA2 } from "./light/sageA.mjs";
import { sandA as sandA2 } from "./light/sandA.mjs";
import { skyA as skyA2 } from "./light/skyA.mjs";
import { slateA as slateA2 } from "./light/slateA.mjs";
import { tealA as tealA2 } from "./light/tealA.mjs";
import { tomatoA as tomatoA2 } from "./light/tomatoA.mjs";
import { violetA as violetA2 } from "./light/violetA.mjs";
import { yellowA as yellowA2 } from "./light/yellowA.mjs";
import { blackA } from "./blackA.mjs";
import { whiteA } from "./whiteA.mjs";
export { amber2 as amber, amberA2 as amberA, amber as amberDark, amberA as amberDarkA, blackA, blue2 as blue, blueA2 as blueA, blue as blueDark, blueA as blueDarkA, bronze2 as bronze, bronzeA2 as bronzeA, bronze as bronzeDark, bronzeA as bronzeDarkA, brown2 as brown, brownA2 as brownA, brown as brownDark, brownA as brownDarkA, crimson2 as crimson, crimsonA2 as crimsonA, crimson as crimsonDark, crimsonA as crimsonDarkA, cyan2 as cyan, cyanA2 as cyanA, cyan as cyanDark, cyanA as cyanDarkA, gold2 as gold, goldA2 as goldA, gold as goldDark, goldA as goldDarkA, grass2 as grass, grassA2 as grassA, grass as grassDark, grassA as grassDarkA, gray2 as gray, grayA2 as grayA, gray as grayDark, grayA as grayDarkA, green2 as green, greenA2 as greenA, green as greenDark, greenA as greenDarkA, indigo2 as indigo, indigoA2 as indigoA, indigo as indigoDark, indigoA as indigoDarkA, lime2 as lime, limeA2 as limeA, lime as limeDark, limeA as limeDarkA, mauve2 as mauve, mauveA2 as mauveA, mauve as mauveDark, mauveA as mauveDarkA, mint2 as mint, mintA2 as mintA, mint as mintDark, mintA as mintDarkA, olive2 as olive, oliveA2 as oliveA, olive as oliveDark, oliveA as oliveDarkA, orange2 as orange, orangeA2 as orangeA, orange as orangeDark, orangeA as orangeDarkA, pink2 as pink, pinkA2 as pinkA, pink as pinkDark, pinkA as pinkDarkA, plum2 as plum, plumA2 as plumA, plum as plumDark, plumA as plumDarkA, purple2 as purple, purpleA2 as purpleA, purple as purpleDark, purpleA as purpleDarkA, red2 as red, redA2 as redA, red as redDark, redA as redDarkA, sage2 as sage, sageA2 as sageA, sage as sageDark, sageA as sageDarkA, sand2 as sand, sandA2 as sandA, sand as sandDark, sandA as sandDarkA, sky2 as sky, skyA2 as skyA, sky as skyDark, skyA as skyDarkA, slate2 as slate, slateA2 as slateA, slate as slateDark, slateA as slateDarkA, teal2 as teal, tealA2 as tealA, teal as tealDark, tealA as tealDarkA, tomato2 as tomato, tomatoA2 as tomatoA, tomato as tomatoDark, tomatoA as tomatoDarkA, violet2 as violet, violetA2 as violetA, violet as violetDark, violetA as violetDarkA, whiteA, yellow2 as yellow, yellowA2 as yellowA, yellow as yellowDark, yellowA as yellowDarkA };
//# sourceMappingURL=index.mjs.map
